import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    requestBody: {},
    requestType: null,
    prnInquireData: null,
    isLoading: false,
    error: null,
};

const prnInquire = createSlice({
    name: "prnInquire",
    initialState,
    reducers: {
        prep: (state, payload) => {
            state.requestBody = payload.requestBody
            state.requestType = payload.requestType
            state.isLoading = true;
            state.error = null;
        },
        setPrnInquireData: (state, payload ) => {
            const data = payload.result.data;
            if (isApiErrorResponse(data)) {
                applyErrorState(state, payload);
            } else {
                state.prnInquireData = data;
                state.isLoading = false;
                state.error = null;
                state.requestType = null;
            }
        },
        error: (state, payload) => {
            applyErrorState(state, payload);
        }
    },
});

const {
    prep,
    error,
    setPrnInquireData,
} = prnInquire.actions;

const getPrnInquireData = async (client, state) => {
    return await client.post(`v2/billers/${state.prnInquire.requestBody.code}/inquiry/${state.prnInquire.requestBody.referenceNumber}`, state.prnInquire.requestBody)
}

const getPrnInquireDataAction = (requestBody) => {
    const requestType = "PRN_DATA"
    return {
        types: [prep.type, setPrnInquireData.type, error.type],
        promise: getPrnInquireData,
        requestBody,
        requestType
    };
}

const isErrorObject = (obj) =>
    typeof obj === 'object' &&
    obj !== null &&
    !Array.isArray(obj);

const handleGenericError = (payload) => {
    const fieldKeys = ["referenceNumber","amount"];
    let genericMessage = 'inquiring SSS Payment Reference Number'
    let errorResult = null
    if(isErrorObject(payload.result) && payload.statusCode === 422){
        errorResult = {
                errorCode: "API3_ERROR_SSS_INQUIRY_PRN",
                errorMessage: payload.result.details.message,
                errorStatusCode: 422,
                requestBody: payload.requestBody,
                errorFieldKey: fieldKeys.includes(Object.keys(payload.result.errors)[0]) ? Object.keys(payload.result.errors)[0] : fieldKeys[0]
            }
    }else{
        switch (payload.requestType) {
            case 'PRN_DATA':
                genericMessage = 'inquiring SSS Payment Reference Number'
                break;
        }
        errorResult = {
                errorCode: "API3_ERROR_SSS_INQUIRY_PRN",
                errorMessage:
                    `SSS PRN Inquiry - We encountered a problem while ${genericMessage}. Kindly retry to generate in a few minutes.`,
                errorStatusCode: 500,
                requestBody: payload.requestBody,
                errorFieldKey: fieldKeys[0]
            }
    }
    return errorResult;
}

const applyErrorState = (state, payload) => {
    state.error = handleGenericError(payload);
    state.prnInquireData = null;
    state.isLoading = false;
    state.requestType = null;
};

const isApiErrorResponse = (data) =>
  data && typeof data === 'object' &&
  'status' in data &&
  data.status >= 400;

export default prnInquire.reducer;

export {
    getPrnInquireDataAction
};
